export default __webpack_public_path__ + "static/media/hht1_song_20.727dad8a.png";